module.exports = __webpack_public_path__ + "static/media/book_cover_p.11b5a65e.jpg";